

export const FETCH_COMMUNITIES_REQUEST = 'communities/FETCH_COMMUNITIES_REQUEST';
export const FETCH_COMMUNITIES_SUCCESS = 'communities/FETCH_COMMUNITIES_SUCCESS';
export const FETCH_COMMUNITIES_FAILURE = 'communities/FETCH_COMMUNITIES_FAILURE';


export const FETCH_COMMUNITY_REQUEST = 'communities/FETCH_COMMUNITY_REQUEST';
export const FETCH_COMMUNITY_SUCCESS = 'communities/FETCH_COMMUNITY_SUCCESS';
export const FETCH_COMMUNITY_FAILURE = 'communities/FETCH_COMMUNITY_FAILURE';


export const DELETE_COMMUNITY_REQUEST = 'communities/DELETE_COMMUNITY_REQUEST';
export const DELETE_COMMUNITY_SUCCESS = 'communities/DELETE_COMMUNITY_SUCCESS';
export const DELETE_COMMUNITY_FAILURE = 'communities/DELETE_COMMUNITY_FAILURE';


export const CREATE_COMMUNITY_REQUEST = 'communities/CREATE_COMMUNITY_REQUEST';
export const CREATE_COMMUNITY_SUCCESS = 'communities/CREATE_COMMUNITY_SUCCESS';
export const CREATE_COMMUNITY_FAILURE = 'communities/CREATE_COMMUNITY_FAILURE';


export const UPDATE_COMMUNITY_REQUEST = 'communities/UPDATE_COMMUNITY_REQUEST';
export const UPDATE_COMMUNITY_SUCCESS = 'communities/UPDATE_COMMUNITY_SUCCESS';
export const UPDATE_COMMUNITY_FAILURE = 'communities/UPDATE_COMMUNITY_FAILURE';


export const UPDATE_FIELD = 'communities/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'communities/SET_DEFAULT_DATA';
